import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const ConfirmActionModal = ({
  show,
  title,
  message,
  confirmLabel = 'Onayla',
  cancelLabel = 'Vazgeç',
  confirmVariant = 'danger',
  isProcessing = false,
  onConfirm,
  onClose,
}) => (
  <Modal show={show} onHide={isProcessing ? undefined : onClose} centered dialogClassName="venue-confirm-modal">
    <Modal.Header closeButton={!isProcessing}>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <div className="venue-modal-actions">
        <Button variant="outline-secondary" onClick={onClose} disabled={isProcessing}>
          {cancelLabel}
        </Button>
        <div className="venue-modal-actions__spacer" />
        <Button variant={confirmVariant} onClick={onConfirm} disabled={isProcessing}>
          {isProcessing ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              İşleniyor...
            </>
          ) : (
            confirmLabel
          )}
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default ConfirmActionModal;
